@if (cell.show) {
  <svg sh-icon [name]="'check'" aria-hidden="true"></svg>
}
